/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicEnvironmentIcon extends BaseIcon {
  getChildren = () => [ <path d="M14,8V22h9V8Zm4,10H16V16h2Zm0-4H16V12h2Zm3,4H19V16h2Zm0-4H19V12h2Z" fill={ this.getColor() }/>,
    <path d="M2,2V22H13V2ZM9,17H4V15H9Zm0-4H4V11H9ZM9,9H4V7H9Z" fill={ this.getColor() }/> ]
  getViewBox = () => '0 0 24 24'
}
